export const texts = {
  emailAcknowledgeExpiredTokenTitle: 'Something went wrong',
  emailAcknowledgeExpiredTokenText:
    'This notification has expired, please log in to the Well Manager website to review the current state of the alert.',
  emailAcknowledgeNotExpiredTokenTitle: 'Confirmation',
  emailAcknowledgeNotExpiredTokenText:
    'You are about to acknowledge the alert, leave a note below (optional) then click OK. ',
}
